import { dealerwiseConstants } from '../constants';

export function dealerwise(state = {}, action) {
    switch (action.type) {
        case dealerwiseConstants.LOADING_REQUEST:
            return {
                ...state,
                loading: action.isbool
            };
        case dealerwiseConstants.GETALL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case dealerwiseConstants.GETALL_SUCCESS:
            return {
                ...state,
                items: action.datas
            };
        case dealerwiseConstants.GETALL_FAILURE:
            return {
                ...state,
                error: action.error
            };
        case dealerwiseConstants.GETEXPORT_REQUEST:
            return {
                ...state,
                exporting: true
            };
        case dealerwiseConstants.GETEXPORT_SUCCESS:
            return {
                ...state,
                exportitems: action.datas
            };
        case dealerwiseConstants.GETEXPORT_FAILURE:
            return {
                ...state,
                error: action.error
            };
        default:
            return state
    }

}